import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { commonReducer } from './commonRedux';
import { authReducer } from './authRedux';
import { modalReducer } from './modalRedux';
import { themeReducer } from './themeRedux';
import { usersReducer } from './usersRedux';
import { contentReducer } from './contentRedux';
import { reportReducer } from './reportRedux';
import { quarantineReducer } from './quarantineRedux';
import { testingReducer } from './testRedux';
import { depositionReducer } from './depositionRedux';
import { filesReducer } from './fileRedux';

/* ------------- Assemble The Reducers ------------- */
const createRootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    common: commonReducer,
    auth: authReducer,
    modal: modalReducer,
    theme: themeReducer,
    users: usersReducer,
    content: contentReducer,
    report: reportReducer,
    quarantine: quarantineReducer,
    testing: testingReducer,
    deposition: depositionReducer,
    file: filesReducer,
  });

export default createRootReducer;
